import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { isArray, find, template } from 'lodash';
import { fetchSeasons, getSeasons, selectSeason, getSelectedSeason,
  fetchLeaguesBySeason, getLeaguesBySelectedSeason,
  selectLeagues, getSelectedLeagues, fetchTeamsByLeague,
  selectTeams, getTeamsBySelectedSeasonAndLeague,
  getSelectedTeams } from '../../../../core/duck';
import Box from '../../../../components/Box';
import Select from '../../../../components/Select';
import Spinner from '../../../../components/Spinner';
import { slugify } from '../../../../utils';

class TeamFilter extends React.Component {
  componentDidMount() {
    const { dispatch, selectedSeason, leaguesBySeason,
      selectedLeagues, teamsByLeague } = this.props;
    dispatch(fetchSeasons());
    if (selectedSeason && !leaguesBySeason.length) {
      dispatch(fetchLeaguesBySeason(selectedSeason));
    }
    if (selectedLeagues.length && !teamsByLeague.length) {
      dispatch(fetchTeamsByLeague(selectedSeason, selectedLeagues));
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.selectedSeason !== this.props.selectedSeason) {
      this.selectedSeasonChange(nextProps.selectedSeason);
    }

    if (nextProps.selectedLeagues.join(",") !==
          this.props.selectedLeagues.join(",")) {
      this.selectedLeaguesChange(nextProps.selectedSeason,
        nextProps.selectedLeagues);
    }
  }

  resetSelectedLeagues = () => {
    this.props.dispatch(selectLeagues([]));
  };

  resetSelectedTeams = () => {
    this.props.dispatch(selectTeams([]));
  };

  handleSeasonChange = (_, seasonId) => {
    const { dispatch } = this.props;
    dispatch(selectSeason(seasonId));
  }

  selectedSeasonChange = (seasonId) => {
    const { dispatch } = this.props;
    dispatch(fetchLeaguesBySeason(seasonId));
    this.resetSelectedLeagues();
  }

  handleLeaguesChange = (_, leagueIds) => {
    const { dispatch } = this.props;
    dispatch(selectLeagues(isArray(leagueIds) ? leagueIds : [leagueIds]));
  }

  selectedLeaguesChange = (seasonId, leagueIds) => {
    const { dispatch } = this.props;
    dispatch(fetchTeamsByLeague(seasonId, leagueIds));
    this.resetSelectedTeams();
  }

  handleTeamsChange = (_, teamIds) => {
    const { dispatch } = this.props;
    dispatch(selectTeams(isArray(teamIds) ? teamIds : [teamIds]));
  }

  getCompiledLink = () => {
    const { seasons, selectedSeason, leaguesBySeason,
      selectedLeagues, teamsByLeague, selectedTeams, link } = this.props;

    let slugs = [];

    if (selectedSeason && seasons.items.length) {
      slugs.push(slugify(find(seasons.items, { key: selectedSeason }).value));
    } else {
      slugs.push('');
    }

    if (selectedLeagues.length && leaguesBySeason.items.length) {
      slugs.push(slugify(find(leaguesBySeason.items, { key: selectedLeagues[0] }).value));
    } else {
      slugs.push('');
    }

    if (selectedTeams.length && teamsByLeague.items.length) {
      slugs.push(slugify(find(teamsByLeague.items, { key: selectedTeams[0] }).value));
    } else {
      slugs.push('');
    }

    return template(link)({
      season: selectedSeason,
      seasonSlug: slugs[0],
      leagues: selectedLeagues.join(","),
      leagueSlug: slugs[1],
      teams: selectedTeams.join(","),
      teamSlug: slugs[2]
    });
  }

  render() {
    const { seasons, selectedSeason, leaguesBySeason,
      selectedLeagues, teamsByLeague, selectedTeams } = this.props;

    const compiledLink = this.getCompiledLink();

    return (
      <Box>
        { seasons.isFetching &&
          <Spinner />
        }
        <div className="row">
          <div className="col-md-11">
            <div className="row">
              <div className="col-md-4">
                <Select options={ seasons.items }
                        placeholder="Select a Season"
                        value={ selectedSeason }
                        onChange={ this.handleSeasonChange } />
              </div>
              {/* .col-md-4 */}
              <div className="col-md-4">
                <Select options={ leaguesBySeason.items }
                        placeholder="Select a League"
                        value={ selectedLeagues }
                        onChange={ this.handleLeaguesChange } />
              </div>
              {/* .col-md-4 */}
              <div className="col-md-4">
                <Select options={ teamsByLeague.items }
                        placeholder="Select a Team"
                        value={ selectedTeams }
                        onChange={ this.handleTeamsChange } />
              </div>
              {/* .col-md-4 */}
            </div>
            {/* .row */}
          </div>
          {/* .col-md-11 */}
          <div className="col-md-1">
          {
            (!selectedTeams || !selectedTeams.length) ?
            <button type="button"
                    className="btn btn-block btn-default disabled">
              <span className="glyphicon glyphicon-ok" aria-hidden="true"></span>
            </button>
            :
            <Link to={ compiledLink }>
              <button type="button"
                      className="btn btn-block btn-default">
                <span className="glyphicon glyphicon-ok" aria-hidden="true"></span>
              </button>
            </Link>
          }
          </div>
          {/* .col-md-1 */}
        </div>
        {/* .row */}
      </Box>
    );
  }
}

export default connect(
  state => ({
    seasons: getSeasons(state),
    selectedSeason: getSelectedSeason(state),
    leaguesBySeason: getLeaguesBySelectedSeason(state),
    selectedLeagues: getSelectedLeagues(state),
    teamsByLeague: getTeamsBySelectedSeasonAndLeague(state),
    selectedTeams: getSelectedTeams(state)
  })
)(TeamFilter);



// WEBPACK FOOTER //
// ./src/features/team-filter/containers/TeamFilter/TeamFilter.js